import { Controller } from 'react-hook-form';
import { useLocalForm } from './useLocalForm';
import * as React from 'react';
import {
  Button,
  FormGroup,
  CustomInput,
  Col,
  Row,
  Label,
  Icon,
  Input,
} from '@polichat/flamboyant';
import { LocalFormValues } from './useLocalForm/types';
import { DtoData } from '../../../../../services/tools/channels/logsChannels/types/dtoAllChannels';
import { DtoAllUsers } from '../../../../../services/tools/channels/logsChannels/types/dtoAllUsers';
import { FormFeedback } from 'reactstrap';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export interface ListChannels {
  loading: boolean;
  data?: DtoData[];
}
export interface ListUsers {
  loading: boolean;
  data?: DtoAllUsers[];
}
export interface FilterLogsProps {
  onSubmit(values: LocalFormValues): void;
  channelList?: ListChannels;
  userList?: ListUsers;
  customerFilter: number;
}
export interface SelectCustomerLogsProps {
  setCurrentCustomer(value: number): void;
}

export function FilterLogs(props: FilterLogsProps) {
  const form = useLocalForm();
  
  // Traduções
  const channelsLabelText = useGlotaT('spa.tools.yourChannels');
  const usersLabelText = useGlotaT('spa.admin.users');
  const typeOfChangeText = useGlotaT('spa.tools.logsTypeOfChange');
  const filterByChannelText = useGlotaT('spa.tools.logsFilterByChannel');
  const loadingText = useGlotaT('spa.tools.loading');
  const allChannelsText = useGlotaT('spa.tools.logsAllChannels');
  const noChannelsText = useGlotaT('spa.tools.logsNoChannels');
  const filterByUserText = useGlotaT('spa.tools.logsFilterByUser');
  const allUsersText = useGlotaT('spa.tools.logsAllUsers');
  const noUsersText = useGlotaT('spa.tools.logsNoUsers');
  const allChangesText = useGlotaT('spa.tools.logsAllChanges');
  const activatedText = useGlotaT('spa.tools.logsActivated');
  const deactivatedText = useGlotaT('spa.tools.logsDeactivated');
  const deletedText = useGlotaT('spa.tools.logsDeleted');
  const disconnectedText = useGlotaT('spa.tools.logsDisconnected');
  const connectedText = useGlotaT('spa.tools.logsConnected');
  const sinceDateText = useGlotaT('spa.tools.logsSinceDate');
  const untilDateText = useGlotaT('spa.tools.logsUntilDate');
  const searchText = useGlotaT('spa.tools.logsSearch');

  return (
    <>
      <Row style={{ alignItems: 'flex-end' }}>
        <Col sm={12} md={4}>
          <FormGroup>
            <Label for={'filtro-canal'}>
              <Icon icon="poli-icon pi-channels-line" size={18} />
              {channelsLabelText}:{' '}
            </Label>
            <Controller
              control={form.control}
              name={'channel_id'}
              render={({ field }) => (
                <CustomInput
                  type="select"
                  id="filtro-canal"
                  onChange={field.onChange}
                  value={field.value}
                  disabled={props.channelList?.loading}
                >
                  <optgroup
                    disabled={props.channelList?.loading}
                    label={filterByChannelText}
                  >
                    <option value="">
                      {props.channelList?.loading
                        ? loadingText
                        : allChannelsText}
                    </option>
                    {props.channelList?.data ? (
                      props.channelList?.data?.map((channel: any) => (
                        <option key={channel.id} value={channel.id}>
                          {channel.name}
                        </option>
                      ))
                    ) : (
                      <option value="">{noChannelsText}</option>
                    )}
                  </optgroup>
                </CustomInput>
              )}
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={4}>
          <FormGroup>
            <Label for={'filtro-usuario'}>
              <Icon icon="poli-icon pi-perfil-line" size={18} />
              {usersLabelText}:{' '}
            </Label>
            <Controller
              control={form.control}
              name={'user_id'}
              render={({ field }) => (
                <CustomInput
                  type="select"
                  id="filtro-usuario"
                  onChange={field.onChange}
                  value={field.value}
                  disabled={props.userList?.loading}
                >
                  <optgroup
                    disabled={props.userList?.loading}
                    label={filterByUserText}
                  >
                    <option value="">
                      {props.userList?.loading
                        ? loadingText
                        : allUsersText}
                    </option>
                    {props.userList?.data ? (
                      props.userList.data?.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.name}
                        </option>
                      ))
                    ) : (
                      <option value="">{noUsersText}</option>
                    )}
                  </optgroup>
                </CustomInput>
              )}
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={4}>
          <FormGroup>
            <Label for={'filtro-estado-canal'}>
              <Icon icon="poli-icon pi-text-left-line" size={18} />
              {typeOfChangeText}:{' '}
            </Label>
            <Controller
              control={form.control}
              name={'type_change'}
              render={({ field }) => (
                <CustomInput
                  type="select"
                  id="filtro-estado-canal"
                  onChange={field.onChange}
                  value={field.value}
                >
                  <optgroup label={typeOfChangeText}>
                    <option value="">{allChangesText}</option>
                    <option value="ativado">{activatedText}</option>
                    <option value="desativado">{deactivatedText}</option>
                    <option value="excluido">{deletedText}</option>
                    <option value="desconectado">{disconnectedText}</option>
                    <option value="conectado">{connectedText}</option>
                  </optgroup>
                </CustomInput>
              )}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row style={{ alignItems: 'flex-end' }}>
        <Col sm={12} md={4}>
          <FormGroup>
            <Label for={'filtro-data-start'}>
              <Icon icon="pi-calendar-line" size={18} />
              {sinceDateText}{' '}
            </Label>
            <Controller
              control={form.control}
              name={'date_start'}
              render={({ field, fieldState }) => (
                <>
                  <Input
                    type="date"
                    invalid={!!fieldState.error}
                    onChange={field.onChange}
                    value={field.value}
                  />
                  <FormFeedback style={{ position: 'absolute' }}>
                    {fieldState.error?.message}
                  </FormFeedback>
                </>
              )}
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={4}>
          <FormGroup>
            <Label for={'filtro-data-end'} style={{ marginTop: '1rem' }}>
              <Icon icon="pi-calendar-line" size={18} />
              {untilDateText}{' '}
            </Label>
            <Controller
              control={form.control}
              name={'date_end'}
              render={({ field, fieldState }) => (
                <>
                  <Input
                    type="date"
                    invalid={!!fieldState.error}
                    disabled={!form.watchValues.DateStart}
                    onChange={field.onChange}
                    value={field.value}
                  />
                  <FormFeedback style={{ position: 'absolute' }}>
                    {fieldState.error?.message}
                  </FormFeedback>
                </>
              )}
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={4}>
          <FormGroup>
            {' '}
            <Button
              style={{ marginTop: '1rem', width: '100%' }}
              onClick={form.handleSubmit(props.onSubmit)}
              disabled={props.channelList?.loading || props.userList?.loading}
            >
              {searchText}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}
